module.exports = __webpack_public_path__ + "img/GestordeLeads.917f8498.svg";